import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CommunityState {
  searchQuery: string
  immediateSearchValue: string
}

interface CommunityActions {
  setSearchQuery: (query: string) => void
  setImmediateSearchValue: (value: string) => void
  clearSearch: () => void
}

type CommunityStore = CommunityState & CommunityActions

const initialState: CommunityState = {
  searchQuery: '',
  immediateSearchValue: '',
}

export const useCommunityStore = create<CommunityStore>()(
  persist(
    (set) => ({
      ...initialState,

      setSearchQuery: (searchQuery) =>
        set((state) => ({
          ...state,
          searchQuery,
        })),

      setImmediateSearchValue: (immediateSearchValue) =>
        set((state) => ({
          ...state,
          immediateSearchValue,
        })),

      clearSearch: () =>
        set((state) => ({
          ...state,
          searchQuery: '',
          immediateSearchValue: '',
        })),
    }),
    {
      name: 'community-store',
      storage: {
        getItem: (name) => {
          const str = sessionStorage.getItem(name) // Use sessionStorage for session-scoped data
          return str ? JSON.parse(str) : null
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => sessionStorage.removeItem(name),
      },
    },
  ),
)
